import { StyleSheet } from 'aphrodite';
import TileBackgroundImageUrl from '../../../assets/editAutomationTemplateBackground.png';
import { THEME } from '../../../components-v2/Theme/theme';
import { destructive, titles, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const {
	typography: { fontSizes },
	spacing,
	colors,
	common,
	breakpoints,
} = THEME;

export const styleSheet = StyleSheet.create({
	surveySettingsContainer: {
		marginBottom: spacing.sm,
		paddingInline: spacing.xl,
		paddingTop: spacing.xxl,
		height: 'auto !important',
		boxSizing: 'border-box',
	},
	addOptionButton: {
		justifyContent: 'flex-start',
	},
	surveySettingsTabRoot: {
		background: THEME.colors.background.light,
		padding: spacing.md,
		borderRadius: common.borderRadius,
	},
	donationSurveyContainer: {
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		fontSize: fontSizes.sm,
		width: '100%',
		background: THEME.colors.background.light,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: `${spacing.md}px ${spacing.md}px ${spacing.md}px 0`,
	},
	section: {
		padding: `${spacing.md}px ${spacing.md}px 0`,
		...CssSelectors.allChildren(
			{
				marginBottom: spacing.md,
			},
			':not(:last-child)'
		),
	},
	sectionTitle: {
		color: titles,
		fontSize: fontSizes.lg,
		fontWeight: 600,
	},
	tabViewContainer: {
		position: 'relative',
		zIndex: 1,
		height: `100%`,
	},
	tabList: {
		position: 'relative',
		zIndex: 1,
		background: white,
		borderBottom: common.border,
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		height: spacing.xl,
		paddingInline: spacing.md,
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				width: 'auto',
				flex: 0,
				textTransform: 'capitalize',
				fontSize: fontSizes.sm,
				padding: `${spacing.sm}px ${spacing.md}px`,
				display: 'flex',
				alignItems: 'center',
			},
			'button'
		),
	},
	tabTextError: {
		color: `${destructive} !important`,
	},
	bodyBackground: {
		backgroundImage: `url(${TileBackgroundImageUrl})`,
		backgroundRepeat: 'repeat',
		backgroundSize: 60,
		bottom: 0,
		content: '',
		display: 'block',
		height: '100%',
		left: 0,
		opacity: 0.2,
		position: 'absolute',
		right: 0,
		top: 0,
		width: '100%',
		zIndex: 0,
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'flex-start',
		width: '100%',
		alignItems: 'center',
		padding: '40px 0',
	},
	additionalQuestionsContainer: {
		width: '100%',
		maxWidth: 766,
		position: 'relative',
		zIndex: 1,
	},
	tabContent: {
		background: THEME.colors.background.main,
		overflowY: 'auto',
	},
	tabContentLight: {
		background: THEME.colors.background.light,
	},
	newTabContent: {
		flexGrow: 1,
	},
	page: {
		background: THEME.colors.background.light,
		padding: '0 !important',
	},
	formSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
	},
	formField: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	formFieldSelect: {
		display: 'grid',
		gridTemplateColumns: '1fr 170px',
		gap: spacing.md,
	},
	formFieldLabelContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	formFieldLabelWithToggleContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.xs,
		justifyContent: 'space-between',
	},
	formFieldLabel: {
		color: colors.text.main,
		fontSize: fontSizes.sm,
		fontWeight: 500,
	},
	formFieldDescription: {
		color: colors.text.light,
		fontSize: fontSizes.xs,
		lineHeight: 1.5,
	},
	donationValuesContainer: {
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: 'repeat(1, 1fr)',

		[`@media (min-width: ${breakpoints.md}px)`]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
		[`@media (min-width: ${breakpoints.lg}px)`]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
		[`@media (min-width: ${breakpoints.xl}px)`]: {
			gridTemplateColumns: 'repeat(4, 1fr)',
		},
	},
	donationValue: {
		cursor: 'pointer',
	},
	donationValueContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
	},
	serviceFeeCalculationMethodContainer: {
		display: 'grid',
		gridTemplateColumns: '200px 200px',
		gap: spacing.md,
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: fontSizes.sm,
	},
	fullWidth: {
		width: '100% !important',
	},
	relative: {
		position: 'relative',
	},
	causeDetailsTextArea: {
		backgroundColor: 'transparent',
		minHeight: '4lh',
		boxSizing: 'content-box',
		width: 'calc(100% - 24px)',
	},
	selectedCampaignsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.xs,
		marginBottom: spacing.sm,
	},
	campaignBadgeWrapper: {
		position: 'relative',
		display: 'inline-flex',
		alignItems: 'center',
		':hover .campaign-badge-remove': {
			opacity: 1,
		},
	},
	campaignBadgeRemove: {
		position: 'absolute',
		top: -6,
		right: -6,
		width: 16,
		height: 16,
		borderRadius: '50%',
		backgroundColor: colors.text.light,
		border: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		padding: 0,
		opacity: 0,
		transition: 'opacity 0.2s ease-in-out, background-color 0.2s ease-in-out',
		':hover': {
			backgroundColor: colors.text.main,
		},
	},
	campaignSearchWrapper: {
		width: '100% !important' as any,
	},
	campaignSearchDropdown: {
		position: 'absolute !important' as any,
		width: 'calc(100% + 2px) !important' as any,
		left: '-1px !important' as any,
		marginTop: '0 !important' as any,
		top: '100% !important' as any,
		borderTop: 'none !important' as any,
	},
	selectTrigger: {
		width: 170,
	},
});
